<!--
  App.vue · 仅 RouterView · 不再加 SolarBackground 全屏 canvas
  深空 + 极光 backdrop 通过 style.css 的 radial-gradient 实现 (无 GPU 重负担)
-->
<script setup>
import { RouterView } from 'vue-router'
</script>

<template>
  <RouterView />
</template>
